<template>
  <table class="table table-google table-highlight w-100">
    <thead>
      <tr>
        <th class="text-nowrap">
          <div class="flex flex-col gap-1">
            <div>Name</div>
            <div>
              <small class="text-gray-600">Reference</small>
            </div>
          </div>
        </th>
        <th>Created</th>
        <th>Updated</th>
        <th>Brand</th>
        <th>Glass</th>
        <th>Wax</th>
        <th>Wick</th>
        <th>Additives</th>
        <th>Dyes</th>
        <th>Fragrances</th>
        <th>Stock</th>
        <th>Offers</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="candle in candles" :key="candle.id">
        <td>
          <div class="flex flex-col gap-1">
            <div>{{ candle.candle_name }}</div>
            <div class="flex gap-2 items-center">
              <icon-star v-if="candle.is_favorite" :checked="candle.is_favorite" class="text-xs" />
              <div>
                <small class="text-gray-600">{{ candle.candle_reference }}</small>
              </div>
            </div>
          </div>
        </td>
        <td class="row-fit">{{ candle.create_date | isodate }}</td>
        <td class="row-fit">{{ candle.update_date | isodate }}</td>
        <td>{{ candle.brand_text }}</td>
        <td>{{ candle.glass_text }}</td>
        <td>{{ candle.wax_text }}</td>
        <td>
          <div class="flex gap-2 text-nowrap">
            <span v-if="candle.wick_count > 1">
              {{ candle.wick_count }}x
            </span>
            <span>{{ candle.wick_text }}</span>
            <span v-if="candle.wick_thickness_id">
              ({{ candle.wick_thickness_text }})
            </span>
          </div>
        </td>
        <td>
          <div class="flex flex-col gap-2">
            <div
              v-for="additive in candle.additive"
              :key="additive.id"
              class="flex gap-4 justify-between"
            >
              <div>{{ additive.name_text }}</div>
              <div>{{ additive.pct_text }}</div>
            </div>
          </div>
        </td>
        <td>
          <div class="flex flex-col gap-2">
            <div
              v-for="dye in candle.dye"
              :key="dye.id"
            >
              <div>{{ dye.name_text }}</div>
            </div>
          </div>
        </td>
        <td>
          <div class="flex flex-col gap-2">
            <div
              v-for="fragrance in candle.fragrance"
              :key="fragrance.id"
              class="flex gap-4 justify-between"
            >
              <div>{{ fragrance.name_text }}</div>
              <div>{{ fragrance.pct_text }}</div>
            </div>
          </div>
        </td>
        <td class="row-fit text-right">
          <span v-if="candle.product_stock">
            {{ candle.product_stock | format }}
          </span>
        </td>
        <td class="row-fit text-right text-nowrap">
          <span v-if="candle.offer_count">
            {{ candle.offer_count | format }}
          </span>
        </td>
        <td class="row-fit">
          <div class="flex gap-2">
            <router-link
              :to="getCandleLink(candle)"
              class="btn btn-primary btn-sm"
              title="View"
            >
              View
            </router-link>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  </template>

<script>
import { getCandleLink } from '@/composables/candle';

const IconStar = () => import('@/components/global/IconStar.vue');

export default {
  name: 'DesktopTable',
  components: {
    IconStar,
  },
  props: {
    candles: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getCandleLink(candle) {
      return getCandleLink(candle, this.filters, 'offers');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
